var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { SearchBar } from './SearchBar';
import { useProfileState } from '../../hooks';
import { fetchShopSearch, fetchPeopleSearch, } from '../../requests/index';
import { AppsResults } from './AppsResults';
import { NetworkResults } from './NetworkResults';
import { ShopResults } from './ShopResults';
import debounce from 'lodash.debounce';
export var SearchCategories;
(function (SearchCategories) {
    SearchCategories["All"] = "all";
    SearchCategories["Apps"] = "apps";
    SearchCategories["Network"] = "network";
    SearchCategories["Shops"] = "shops";
})(SearchCategories || (SearchCategories = {}));
export function NetworkSearch() {
    var _a = useState([]), filteredApps = _a[0], setFilteredApps = _a[1];
    var _b = useState(null), shopResults = _b[0], setShopResults = _b[1];
    var _c = useState(false), shopError = _c[0], setShopError = _c[1];
    var _d = useState(null), peopleResults = _d[0], setPeopleResults = _d[1];
    var _e = useState(false), peopleError = _e[0], setPeopleError = _e[1];
    var _f = useState(SearchCategories.All), category = _f[0], setCategory = _f[1];
    var _g = useState(1), peoplePage = _g[0], setPeoplePage = _g[1];
    var _h = useState(12), peopleLimit = _h[0], setPeopleLimit = _h[1];
    var _j = useState(1), shopsPage = _j[0], setShopsPage = _j[1];
    var _k = useState(12), shopsLimit = _k[0], setShopsLimit = _k[1];
    var _l = useState(false), isNetworkSearching = _l[0], setIsNetworkSearching = _l[1];
    var _m = useState(false), isShopsSearching = _m[0], setIsShopsSearching = _m[1];
    var _o = useState(null), debounceFunctions = _o[0], setDebounceFunctions = _o[1];
    var profile = useProfileState();
    var apps = profile.apps, searchValue = profile.searchValue;
    function filterApps(val) {
        var matchingApps = apps.filter(function (app) {
            var _a, _b;
            return app.label.toLowerCase().includes(val.toLowerCase()) || (((_a = app.keywords) === null || _a === void 0 ? void 0 : _a.length) > 0 ?
                (_b = app.keywords) === null || _b === void 0 ? void 0 : _b.find(function (item) { return item.label.includes(val.toLowerCase()); }) : false);
        });
        matchingApps.sort(function (a, b) {
            var labelA = a.label.toLowerCase();
            var labelB = b.label.toLowerCase();
            return labelA < labelB ? -1 : labelA > labelB ? 1 : 0;
        });
        setFilteredApps(matchingApps);
    }
    function searchShops(val, limit, page) {
        return __awaiter(this, void 0, void 0, function () {
            var shops, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setShopError(false);
                        if (val.length === 0) {
                            setShopResults(null);
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        setIsShopsSearching(true);
                        return [4 /*yield*/, fetchShopSearch(val, limit, page)];
                    case 2:
                        shops = _a.sent();
                        setShopResults(shops);
                        setShopsPage(shops.pageNumber);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        setShopResults(null);
                        setShopError(true);
                        return [3 /*break*/, 4];
                    case 4:
                        setIsShopsSearching(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    function searchPeople(searchVal, limit, page) {
        if (searchVal === void 0) { searchVal = searchValue; }
        if (limit === void 0) { limit = 12; }
        if (page === void 0) { page = 1; }
        return __awaiter(this, void 0, void 0, function () {
            var people, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setPeopleError(false);
                        if (searchVal.length === 0) {
                            setPeopleResults(null);
                            return [2 /*return*/];
                        }
                        setIsNetworkSearching(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fetchPeopleSearch(searchVal, limit, page)];
                    case 2:
                        people = _a.sent();
                        setPeopleResults(people);
                        setPeoplePage(people.pageNumber);
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        setPeopleResults(null);
                        setPeopleError(true);
                        return [3 /*break*/, 4];
                    case 4:
                        setIsNetworkSearching(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    if (!debounceFunctions) {
        setDebounceFunctions({
            searchPeople: debounce(searchPeople, 500),
            searchShops: debounce(searchShops, 500),
        });
    }
    // process search requests and only update state for the most recent query
    useEffect(function () {
        debounceFunctions.searchPeople(searchValue, 12, 1);
        debounceFunctions.searchShops(searchValue, 12, 1);
        if (searchValue.length === 0) {
            setFilteredApps([]);
            setPeopleResults(null);
            setShopResults(null);
            setIsNetworkSearching(false);
            setIsShopsSearching(false);
        }
        else {
            filterApps(searchValue);
        }
    }, [searchValue]);
    // update people data for pagination/per page changes
    useEffect(function () {
        debounceFunctions.searchPeople(searchValue, peopleLimit, peoplePage);
    }, [peoplePage, peopleLimit]);
    // update shop data for pagination/per page changes
    useEffect(function () {
        debounceFunctions.searchShops(searchValue, shopsLimit, shopsPage);
    }, [shopsPage, shopsLimit]);
    return (_jsxs(Container, { children: [_jsx(SearchBar, { category: category, setCategory: setCategory }, void 0),
            filteredApps.length > 0 && (_jsx(AppsResults, { apps: filteredApps, category: category, setCategory: setCategory }, void 0)),
            ((peopleResults === null || peopleResults === void 0 ? void 0 : peopleResults.data) && (peopleResults === null || peopleResults === void 0 ? void 0 : peopleResults.data.length) > 0) ||
                isNetworkSearching ? (_jsx(NetworkResults, { people: peopleResults, category: category, setPage: setPeoplePage, setLimit: setPeopleLimit, setCategory: setCategory, isSearching: isNetworkSearching, isError: peopleError }, void 0)) : null,
            ((shopResults === null || shopResults === void 0 ? void 0 : shopResults.data) && shopResults.data.length > 0) ||
                isShopsSearching ? (_jsx(ShopResults, { shops: shopResults, category: category, setPage: setShopsPage, setLimit: setShopsLimit, setCategory: setCategory, isSearching: isShopsSearching, isError: shopError }, void 0)) : null,
            searchValue !== '' && filteredApps.length === 0 && (_jsx(AppsResults, { apps: filteredApps, isEmpty: true, category: category, setCategory: setCategory }, void 0)),
            (peopleResults && peopleResults.count === 0) || peopleError ? (_jsx(NetworkResults, { people: peopleResults, isEmpty: true, category: category, setPage: setPeoplePage, setLimit: setPeopleLimit, setCategory: setCategory, isSearching: isNetworkSearching, isError: peopleError }, void 0)) : null,
            (shopResults && shopResults.count === 0) || shopError ? (_jsx(ShopResults, { shops: shopResults, isEmpty: true, category: category, setPage: setShopsPage, setLimit: setShopsLimit, setCategory: setCategory, isSearching: isShopsSearching, isError: shopError }, void 0)) : null] }, void 0));
}
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100vw;\n  height: 100vh;\n  z-index: 1000;\n  background: white;\n  position: fixed;\n  top: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  overflow-y: scroll;\n"], ["\n  width: 100vw;\n  height: 100vh;\n  z-index: 1000;\n  background: white;\n  position: fixed;\n  top: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  overflow-y: scroll;\n"])));
var templateObject_1;
